<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="订单状态">
              <a-select v-model="queryParam.order_condition" placeholder="请选择" allowClear>
                <a-select-option value="12">订单付款</a-select-option>
                <a-select-option value="3">订单结算</a-select-option>
                <a-select-option value="13">订单失效</a-select-option>
                <a-select-option value="4">订单退款</a-select-option>
                <a-select-option value="14">订单成功</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="返利状态">
              <a-select v-model="queryParam.rebate_condition" placeholder="请选择" allowClear>
                <a-select-option value="0">未返利</a-select-option>
                <a-select-option value="1">已返利</a-select-option>
                <a-select-option value="2">已退款</a-select-option>
                <a-select-option value="cold">已冻结</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced"> </template>
          <a-col :md="(!advanced && 8) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
            >
              <a-button @click="withdrawalOrder">本次提现包含订单</a-button>
              <a-button style="margin-left: 8px" type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              
              <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator"></div>
    <s-table ref="table" rowKey="id" :scroll="{ x: 2350 }" :columns="columns" :data="loadData">
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="order_no" slot-scope="text">
        <a-tooltip placement="top">
          <template slot="title">
            <span>{{ text }}</span>
          </template>
          <span v-line-clamp="1">{{ text }}</span>
        </a-tooltip>
      </span>
      <span slot="order_title" slot-scope="text, record">
        <a-tooltip placement="top">
          <template slot="title">
            <span>{{ text }}</span>
          </template>
          <!-- <a :href="'https://item.taobao.com/item.htm?id=' + record.item_id" target="_blank" v-line-clamp="1">{{text}}</a> -->
          <a :href="record.item_link" target="_blank" v-line-clamp="1">{{text}}</a>
        </a-tooltip>
      </span>
      <span slot="user_info" slot-scope="text">
        <a-tooltip placement="left" v-if="text">
          <template slot="title">
            <span>{{ text.nickname }}（uid:{{ text.uid }}）</span>
          </template>
          <span v-line-clamp="1">{{ text.nickname }}</span>
        </a-tooltip>
        <a v-else>未绑定</a>
      </span>
      <span slot="item_img" slot-scope="text">
        <a-avatar shape="square" icon="picture" :src="text" />
      </span>
      <span slot="rmb_slot" slot-scope="text">
        <span>{{ text || 0 | currency('￥') }}</span>
      </span>
      <span slot="total_reward" slot-scope="text, record">
        <span v-if="record.tk_status != 14">
          <span>{{ record.pub_share_pre_fee || 0 | currency('￥') }}</span>
        </span>
        <span v-else>
          <span>{{ record.pub_share_fee || 0 | currency('￥') }}</span>
        </span>
      </span>
      <span slot="order_status_slot" slot-scope="text">
        <a-badge v-if="text == '12'" status="processing" text="订单付款" />
        <a-badge v-else-if="text == '3'" status="success" text="订单结算" />
        <a-badge v-else-if="text == '13'" status="default" text="订单失效" />
        <a-badge v-else-if="text == '4'" status="default" text="订单退款" />
        <a-badge v-else-if="text == '14'" status="success" text="订单成功" />
        <span v-else>{{ text | getOrderStatus }}</span>
      </span>
      <span slot="order_fanli_status_slot" slot-scope="text">
        <span>{{ text | getOrderFanliStatus }}</span>
      </span>
      <span slot="accountdt" slot-scope="text">
        <span>{{ text ? text : '暂未结算' }}</span>
      </span>
      <span slot="createdt" slot-scope="text">
        <span>{{ text ? text : '无创建时间' }}</span>
      </span>
      <span slot="adzone_id" slot-scope="text, record">
        <span>{{ record.adzone_id }}</span>
      </span>
      <span slot="order_dongjie_status_slot" slot-scope="text">
        <span>
          <a-tag color="red" v-if="text == '1'">已冻结</a-tag>
          <a-tag color="blue" v-else>未冻结</a-tag>
        </span>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { PageView } from '@/layouts'
import { DATA_ORDER_STATUS, DATA_ORDER_FANLI_STATUS } from '@/views/order/taobao/data.js'
import OrderApi from '@/api/order-new'
export default {
  name: 'OrderTaobao',
  components: {
    PageView,
    STable,
  },
  data() {
    return {
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      //申请时间
      //createdt:'',
      // 表头
      columns: [
        {
          title: '#',
          width: 10,
          scopedSlots: { customRender: 'serial' },
        },
        {
          title: '订单号',
          width: 100,
          dataIndex: 'trade_parent_id',
          scopedSlots: { customRender: 'order_no' },
        },
        {
          title: '主图',
          dataIndex: 'item_img',
          width: 60,
          scopedSlots: { customRender: 'item_img' },
        },
        {
          title: '商品标题',
          width: 200,
          dataIndex: 'item_title',
          scopedSlots: { customRender: 'order_title' },
        },
        {
          title: '商品ID',
          width: 150,
          dataIndex: 'item_id',
        },
        {
          title: '订单状态',
          width: 110,
          dataIndex: 'tk_status',
          scopedSlots: { customRender: 'order_status_slot' },
        },
        {
          title: '付款金额',
          width: 150,
          dataIndex: 'alipay_total_price',
          sorter: true,
          scopedSlots: { customRender: 'rmb_slot' },
        },
        {
          title: '总佣金',
          dataIndex: 'total_commission_fee',
          sorter: true,
          scopedSlots: { customRender: 'total_reward' },
        },
        {
          title: '认领用户',
          width: 150,
          dataIndex: 'user_info',
          scopedSlots: { customRender: 'user_info' },
        },
        {
          title: '用户奖励',
          width: 150,
          dataIndex: 'fl_user',
          sorter: true,
          scopedSlots: { customRender: 'rmb_slot' },
        },
        {
          title: '上级奖励',
          width: 150,
          dataIndex: 'fl_agent',
          sorter: true,
          scopedSlots: { customRender: 'rmb_slot' },
        },
        {
          title: '群主奖励',
          width: 150,
          dataIndex: 'fl_group',
          sorter: true,
          scopedSlots: { customRender: 'rmb_slot' },
        },
        {
          title: '返利状态',
          width: 100,
          dataIndex: 'flstatus',
          scopedSlots: { customRender: 'order_fanli_status_slot' },
        },
        {
          title: '冻结状态',
          width: 100,
          dataIndex: 'luckdrawTAG',
          scopedSlots: { customRender: 'order_dongjie_status_slot' },
        },
        {
          title: '结算时间',
          width: 200,
          dataIndex: 'tk_earning_time',
          sorter: true,
          scopedSlots: { customRender: 'accountdt' },
        },
        {
          title: '推广位',
          width: 150,
          scopedSlots: { customRender: 'adzone_id' },
        },
        {
          title: '创建时间',
          sorter: true,
          dataIndex: 'tb_paid_time',
          scopedSlots: { customRender: 'createdt' },
        },
      ],
      isShow: false,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return OrderApi.getTaobaoOrderList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId,
            search_condition: 3,
            keywords: this.uid,
            createdt:this.createdt,
            select_limit: this.isShow ? 1 : 0
          })
        )
      },
    }
  },
  props: {
    currentRobotId: Number,
    uid: Number,
    createdt:String
  },
  filters: {
    getOrderStatus(status) {
      const dataObj = DATA_ORDER_STATUS
      if (dataObj[status]) {
        return dataObj[status]['text']
      } else {
        return '未知'
      }
    },
    getOrderFanliStatus(status) {
      const dataObj = DATA_ORDER_FANLI_STATUS
      if (dataObj[status]) {
        return dataObj[status]['text']
      } else {
        return '未知'
      }
    },
  },
  created() {},
  methods: {
    withdrawalOrder() {
      console.log(1111)
      this.isShow = true;
      this.$refs.table.refresh(true)
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
  },
}
</script>
<style lang="less" scoped>
</style>
